import { useMutation, useQueryClient } from "@tanstack/react-query";

import { SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY } from "@krea/customer-features/store/queryClient";
import { useGetUserData } from "@krea/customer-features/store/user/hooks/queries/useGetUserData";
import { INoContentResponse } from "@krea/shared/types/response";

import { markAsEligibleForPayment } from "@/services/api/lender-response/actions";

export const useMarkEligibleForPayment = () => {
  const queryClient = useQueryClient();
  const { data } = useGetUserData();
  const loanApplicationID = data?.currentLoanApplication?.id;

  return useMutation<INoContentResponse, Error, { lenderResponseID: string }>({
    mutationFn: async ({ lenderResponseID }) => {
      await markAsEligibleForPayment(lenderResponseID);
    },
    mutationKey: ["markAsEligibleForPayment"],
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        SELECTED_LENDER_RESPONSE_FIELD_REQUESTS_STORE_KEY,
        loanApplicationID,
      ]);
    },
    onError: () =>
      console.error(`Failed to send data for "Mark as eligible for payment"`),
  });
};
